import { axios } from '@Root/API'

export const getContactUpdates = params => {
  return axios.get('cognito-contact-updates', { params })
}
